import React from "react";
import moment from "moment";
import { connect } from "react-redux";
import history from "../../auth/history";
import { CSVLink } from "react-csv";
class UploadHistoryFileListDetails extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			phoneNo: this.props.phone,
			consumerList: []

		}
	}




	componentDidMount() {
		var consumerList1 = [];
		if (this.props.upload.consumerList != undefined &&
			this.props.upload.consumerList.length > 0) {
			var consumerList = this.props.upload.consumerList;
			consumerList.map(consumer => {
				// alert(JSON.stringify(consumer.optional))
				if (consumer.optional != null) {
					const map = new Map(Object.entries(consumer.optional));
					var val = "";
					var mapKeys = [...map.keys()];
					// alert(mapKeys);

					mapKeys.map(key => {
						val = val + key + "=" + map.get(key) + ";"
					})
					consumer.optional = val;
					// alert(JSON.stringify(consumer));
					consumerList1.push(consumer);
				} else {
					consumerList1.push(consumer);
				}

			})

		}

		this.setState({
			consumerList: consumerList1
		})

	}
	componentWillUnmount() {
	}


	render() {

		return (
			<div class="filelist">
				<div class="row">
					<div class="col-8 col-md-4">
						<div class="filetxt">
							<p>Uploaded by  {this.props.upload.agentId}</p>
							<h4>File: {this.props.upload.fileName != undefined && this.props.upload.fileName}</h4>
							<p class="date">{moment(
								this.props.upload.createdOn)
								.format('DD-MM-YYYY HH:mm:ss')}</p>
						</div>
					</div>

					<div class="col-4 col-md">
						<div class="filetxt text-end text-md-start">
							<p>Consumers</p>
							<h5>{(this.props.upload.consumerList != undefined &&
								this.props.upload.consumerList != null) ?
								this.props.upload.consumerList.length : 0}</h5>
						</div>
					</div>

					<div class="col-4 col-md">
						<div class="filetxt">
							<p>Duplicate</p>
							<h5 class="dup">{this.props.upload.duplicate}</h5>
						</div>
					</div>

					<div class="col-3 col-md">
						<div class="filetxt">
							<p>Failed</p>
							<h5 class="fail">{this.props.upload.rejected}</h5>
						</div>
					</div>
					<div class="col-3 col-md">
						<div class="filetxt">
							<p>Success</p>
							<h5 class="success">{this.props.upload.success}</h5>
						</div>
					</div>
					<div class="col-3 col-md">
						<div class="filetxt">
							<p>Upload status</p>
							<h5 class="success">{(this.props.upload.status != null &&
								this.props.upload.status != undefined &&
								this.props.upload.status != "") ?
								this.props.upload.status : 'NA'}</h5>
						</div>
					</div>

					{(this.props.upload.consumerList != undefined &&
						this.props.upload.consumerList.length > 0) ?
						<div class="col-5 col-md">
							<div class="filetxt">
								<CSVLink
									class="downbtn"
									data={this.props.upload.consumerList}
									asyncOnClick={true}
									// onClick={this.resetExportDate}
									filename={this.props.upload.fileName + ".csv"}
								>
									Download
								</CSVLink>
							</div>
						</div> :
						<div class="col-5 col-md">
							<div class="filetxt">
								<button type="button" disabled hidden={true}
								></button>
							</div>
						</div>
					}
				</div>
			</div>
		);
	}
}

const mapStateToProps = (
	{ errorMessageReduce: { errorMessage, },
		miscReduce: { phone } }
) => ({
	errorMessage, phone
});

export default connect(mapStateToProps, null)(UploadHistoryFileListDetails);
